import queryString from "query-string";

import { BUSINESS_LABEL } from "constants/actionTypes";

import { URLCreatorProps } from "actions/types";
import { serializeBusinessLabel } from "lib/serializers/businessLabel";

import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";

const urlCreator = ({ changesSince, id, action }: URLCreatorProps = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/business-labels/", id, action),
    query: {
      changesSince,
    },
  });

export const BusinessLabelAction = offlineActionCreator(
  BUSINESS_LABEL,
  serializeBusinessLabel,
  urlCreator,
  false,
);
